import React, { useRef } from "react";
import { Button } from "react-bootstrap";
// @ts-ignore
import { client } from "filestack-react";
import { AlertService } from "../../services/alert.service";
import service from "../../services/api.service";
import FileStackService from "../../services/filestack.service";
import styles from './index.module.scss';
import { t } from "../../translations/translation.service";

export interface CvUploadAutoFillProps {
  onExtractedData: (data: any) => void;
  onError: (msg: string) => void;
  buttonText?: string;
  unauthenticated?: boolean;
}

const CvUploadAutoFill: React.FC<CvUploadAutoFillProps> = ({
  onExtractedData,
  onError,
  buttonText = t("Autopreenchimento via Currículo"),
  unauthenticated = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const uploadCv = async (file: File) => {
    const pickSecurity = (await FileStackService.getPoliceAndSignature()).data;
    const fileStackClient = client.init(process.env.REACT_APP_FILESTACK_API, {
      security: { policy: pickSecurity.policy, signature: pickSecurity.signature }
    });
    const uploaded = await fileStackClient.upload(file);
    const readSecurity = unauthenticated
      ? await FileStackService.getFileStackSecreteCodeToUserSignup(uploaded.url, false)
      : await FileStackService.getFileStackSecreteCodeToUser(uploaded.url, false);

    return {
      fileName: file.name,
      files: [{ fileName: file.name, url: uploaded.url }],
      policyAndSignature: readSecurity.data
    };
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await service.post("/resume/extract", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      const data = response.data;

      let attachment = {};
      try {
        attachment = await uploadCv(file);
      } catch (uploadErr: any) {
        console.error("Exceção ao anexar o currículo automaticamente:", uploadErr);
        AlertService.error(t("Não foi possível anexar o currículo automaticamente. Anexe o arquivo manualmente."));
      }

      onExtractedData({ ...data, ...attachment });
      AlertService.success("Dados extraídos do currículo e preenchidos automaticamente!");
    } catch (err: any) {
      console.error("Exceção ao extrair dados do currículo:", err);
      onError("Não foi possível processar o arquivo. Verifique o formato e tente novamente.");
      AlertService.error("Não foi possível processar o arquivo. Verifique o formato e tente novamente.");
    }
  };

  return (
    <div className={styles['cv-upload-container']}>
      <Button
        className={styles['add-cv-btn']}
        onClick={() => fileInputRef.current?.click()}
      >
        {buttonText}
      </Button>
      <input
        type="file"
        accept=".pdf,.docx"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
    </div>
  );
};

export default CvUploadAutoFill;